module.exports = __webpack_public_path__ + "img/coins.a848c3d2.png";